const initState = {
  Badges: [],
  allTalkingBadges: null,
  allTalkingData: [],
  contestBadges: [],
  sportBadges: [],
  purchasedTalkingBadges: null,
  favouritesTalking: null,
  Athlete: null,
  isLoading: false,
  lastSeasonal: null,
  lastTalkingDocument: null,
  hasMoreTalikingDoument: true,
  hasMoreSeasonal: true,
};
const talkingReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_TALKING_BADGES":
      return {
        ...state,
        // Badges: [...state.Badges,action.payload.tempData],
        Badges: action.payload.tempData,
        lastSeasonal: action.payload.lastDocument,
        Athlete: action.payload.athletePayload,
        hasMoreSeasonal: action.payload.hasMoreDocuments,
      };
    case "GET_PURCHASED_TALKING_BADGES":
      return {
        ...state,
        purchasedTalkingBadges: action.payload,
      };
    case "GET_ALL_TALKING_BADGES":
      return {
        ...state,
        lastTalkingDocument: action.payload.lastDocument,
        hasMoreTalikingDoument: action.payload.hasMoreDcuments,
        allTalkingBadges: action.payload.data,
        allTalkingData: action.payload.tempData,
      };
    case "GET_TALKING_FAVOURITES":
      return {
        ...state,
        favouritesTalking: action.payload,
      };

    case "GET_CONTEST_BADGES":
      return {
        ...state,
        contestBadges: action.payload,
      };

      case "GET_SPORT_BADGES":
        return {
          ...state,
          sportBadges: action.payload,
        };

    case "LOADING":
      return {
        ...state,
        isLoading: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};
export default talkingReducer;
